const SIP_PASSWORD = import.meta.env.VITE_SIP_PASSWORD || 'Xd239118';

export function useSipPassword() {
  const getSipPassword = async (_extension) => SIP_PASSWORD;
  const refreshSipPassword = async (_extension) => SIP_PASSWORD;
  const clearPasswordCache = () => {};
  const getCacheInfo = () => ({ size: 0, entries: [] });
  return { getSipPassword, refreshSipPassword, clearPasswordCache, getCacheInfo };
}
